import { Tag } from '@equip.health/ui';
import { RiskLevel, RiskLevelToLabel, RiskLevelToTagColors } from './RiskLevel';
type Props = {
  id: string;
  riskLevel: RiskLevel;
};
export const AssessmentCardRiskLevelTag = ({ id, riskLevel }: Props) => {
  return (
    <Tag
      color={RiskLevelToTagColors[riskLevel]}
      id={`assessment-card-risk-tag-${id}`}
      size="sm"
      value={RiskLevelToLabel[riskLevel]}
    />
  );
};
